<div class="chrostmas">
    <img class="img-fluid" src="./../../assets/kamra/karacsony.jpg" alt="Karácsonyi ajándékcsomag hamarosan">
</div>